<template>
  <lk-modal title="商品列表" v-model="val" @on-ok='handleConfirm' @on-cancel="cancel" :closable='false' :mask-closable='false' width='500'>
    <lk-table :columns='columns' border @on-selection-change='handleSelection'
    @on-visible-change='handleVisible' :data='tableData'></lk-table>
  </lk-modal>
</template>
<script>
export default {
  name: 'PrescriptionGoodsModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    able: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  model: {
    event: 'change',
    prop: 'value',
  },
  watch: {
    value(val) {
      this.val = val;
    },
  },
  data() {
    return {
      val: false,
      selected: [],
      columns: [
        {
          type: 'selection',
          width: 60,
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',

        },
        {
          title: '通用名称',
          key: 'approvedDrugNames',

        },
        {
          title: '规格',
          key: 'specifications',

        },
      ],
    };
  },
  methods: {
    handleConfirm() {
      this.$emit('setSelected', this.selected);
    },
    cancel(){
      this.$emit('change', false);
    },
    handleSelection(val) {
      this.selected = val;
      this.selected.forEach((item) => {
        item._checked = true;
      });
    },
    handleVisible(val) {
      if (this.able) {
        this.val = val;
        this.$emit('change', val);
      }
    },
  },
  mounted() {
    this.selected = this.tableData.filter(item => item._checked);
    this.val = this.value;
  },
};
</script>
